import { Modal } from 'react-bootstrap';
import ChatKeys from '@/core/chat/chat-keys/chat-keys';

export default function ChatKeysModal({
  showChatKeysModal,
  setShowChatKeysModal,
}: {
  showChatKeysModal: boolean;
  setShowChatKeysModal: (b: boolean) => void;
}) {
  return (
    <Modal
      show={showChatKeysModal}
      onHide={() => {
        setShowChatKeysModal(false);
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body style={{ height: '80vh', overflowY: 'auto' }}>
        <ChatKeys />
      </Modal.Body>
    </Modal>
  );
}
